// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PP0BF","left":"styles_left__djc9s"};